import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import icon from "../assets/Icon.png";
import logo from "../assets/logo.png";
import down from "../assets/Down.svg";
import right from "../assets/Right.svg";
import nr from "../assets/Nr.png";
import twit from "../assets/Twit.png";
import gate from "../assets/Gate.svg";
import trans from "../assets/Transport.svg";
import asset from "../assets/Asset.svg";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import { Link } from "react-router-dom";
import user from "../assets/User.png";
import dd from "../assets/Data.png";
import sec from "../assets/Sec.png";
import g1 from "../assets/G1.png";
import g2 from "../assets/G2.png";
import g3 from "../assets/G3.png";
import g4 from "../assets/G4.png";
import g5 from "../assets/G5.png";
import g6 from "../assets/G6.png";
import g7 from "../assets/G7.png";
import g8 from "../assets/G8.png";
import d1 from "../assets/D1.png";
import d2 from "../assets/D2.png";
import d3 from "../assets/D3.png";
import d4 from "../assets/D4.png";
import ios from "../assets/IOS.png";
import iosgreen from "../assets/IOSgreen.png";
import pc from "../assets/PC.png";
import pcgreen from "../assets/PCgreen.png";
import playStore from "../assets/Playstore.png";
import appStore from "../assets/Appstore.png";
import load from "../assets/Load.png";
import android from "../assets/Android.png";
import o1 from "../assets/O1.png";
import riarr from "../assets/Rightarr.svg";
import mail from "../assets/Mail.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import phone from "../assets/Phone.png";
import ee from "../assets/Email.png";
import trial from "../assets/Trial.png";
import newsgreen from "../assets/Newsgreen.png";
import androidgreen from "../assets/Androidgreen.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import c1 from "../assets/C1.png";
import c2 from "../assets/C2.png";
import c3 from "../assets/C3.png";
import laptop from "../assets/Laptop.svg";
import p1 from "../assets/P1.png";
import p2 from "../assets/P2.png";
import p3 from "../assets/P3.png";
import bbb from "../assets/BBB.png";
const Features = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Features");
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
  const [isHovered2, setIsHovered2] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const handleClick = (item) => {
    setActiveItem(item);

    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }

    if (item === "Pricing") {
      navigate("/new");
    }

    if (item === "Home") {
      navigate("/");
    }

    if (item === "Say Hello") {
      navigate("/contact");
    }

    if (item === "Partner") {
      navigate("/part");
    }
  };
  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];
  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy-policy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };
  const [showDropdown, setShowDropdown] = useState(false);

 const dropdownItems = [
     {
       title: "LOGISTICS OPERATIONS",
       items: [
    {
   icon: gate,
   name: "Gate",
   description: (
     <>
       Helps organizations track and manage
       <br />
       visitors efficiently.
     </>
   ),
 }
 
         // {
         //   icon: dock,
         //   name: "Dock",
         //   description:
         //     "Helps businesses streamline loading, unloading & scheduling.",
         // },
         // {
         //   icon: sign,
         //   name: "Signage",
         //   description:
         //     "Creating, managing & displaying digital content on screens.",
         // },
       ],
     },
     // {
     //   title: "TRACKING SYSTEM",
     //   items: [
     //     // {
     //     //   icon: trans,
     //     //   name: "Transport",
     //     //   description:
     //     //     "Helps users efficiently manage & optimize transportation services.",
     //     // },
     //     // {
     //     //   icon: bus,
     //     //   name: "Vehicle Management",
     //     //   description:
     //     //     "Tracks vehicles, optimizes routes, and automates expenses.",
     //     // },
     //     // {
     //     //   icon: asset,
     //     //   name: "Asset",
     //     //   description:
     //     //     "Helps businesses track, monitor, and manage assets efficiently.",
     //     // },
     //   ],
     // },
     {
       title: "WORKFORCE MANAGEMENT",
       items: [
         {
   icon: q,
   name: "MeetQ",
   description: (
     <>
       Book & manage meeting rooms
       <br />
       with real-time tracking.
     </>
   ),
 }
 
         // {
         //   icon: tg,
         //   name: "TickGo",
         //   description: "Track tasks, log hours, and update statuses.",
         // },
         // {
         //   icon: n,
         //   name: "Nexus",
         //   description: "Manage attendance, tasks, and productivity.",
         // },
       ],
     },
   ];
  const cardData = [
    {
      title: "Corporate Offices",
      description: `Large corporate offices often have strict security protocols and frequent visitor traffic. A digital gate pass system can efficiently manage visitor check-ins, enhance security measures, and provide a seamless experience for guests.`,
      image: d1,
    },
    {
      title: "Educational Institutions",
      description: `They routinely offer events and meetings for external visitors. A digital gate pass system can make the visitor registration procedure more efficient, ensuring that guests are properly vetted and accounted for on campus.`,
      image: d2,
    },
    {
      title: "Technology Companies",
      description: `Technology organizations frequently have significant intellectual property and sensitive data to protect. A digital gate pass system can assist in controlling entry to company premises, ensuring that only authorized personnel can visit.`,
      image: d3,
    },
    {
      title: "Hospitality",
      description: `From controlling access at event venues and resort areas to providing safe admission at hotel and healthcare facilities, our system ensures seamless operations, increased security, and a positive guest experience.`,
      image: d4,
    },
  ];

  const cardsRef = useRef([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.getAttribute("data-index"));
            setActiveIndex(index);
          }
        });
      },
      { threshold: 0.5 }
    );

    cardsRef.current.forEach((card) => card && observer.observe(card));

    return () => observer.disconnect();
  }, []);



   const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);



  const sectionReff = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );

    const current = sectionReff.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, []);



  const dashboardRef = useRef(null);
  const [dashboardInView, setDashboardInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setDashboardInView(entry.isIntersecting),
      { threshold: 0.3 }
    );

    const current = dashboardRef.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, []);
  

 const isMobile = screenWidth <= 768;
    const isTablet = screenWidth > 768 && screenWidth <= 1024;
       const [isMobileOrTablet, setIsMobileOrTablett] = useState(
      typeof window !== "undefined" ? window.innerWidth <= 1024 : false
    );
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobileOrTablett(window.innerWidth <= 1024);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);


      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        const [mobileProductsOpen, setMobileProductsOpen] = useState(false);

                        // paint immediately
const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

   const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
  
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
  
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
  
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
  
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
  
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
  
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
  
  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };


  const location = useLocation();

  // Scroll to the hash section on mount or hash change
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);
  


  return (
    <div>
              <ToastContainer
         position="bottom-right"
         autoClose={3000}
         style={{ bottom: "80px" }}
       />
     {/* <div
            style={{
              position: "fixed",
              bottom: "5%",
              right: "4%",
              zIndex: 9999,
            }}
            className="floating-button-container"
          >
            <button
              style={{
                padding: 0,
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              <img
                src={icon}
                alt="button icon"
                className="floating-button-icon"
                style={{
                  width: "12vw",
                  height: "12vw",
                  maxWidth: "50px",
                  maxHeight: "50px",
                }}
              />
            </button>
    
            <style>{`
        .floating-button-container {
          transition: all 0.3s ease;
        }
    
        .floating-button-icon {
          transition: width 0.3s ease, height 0.3s ease;
        }
    
        @media screen and (max-width: 768px) {
          .floating-button-container {
            bottom: 6%;
            right: 5%;
          }
          .floating-button-icon {
            width: 10vw;
            height: 10vw;
            max-width: 45px;
            max-height: 45px;
          }
        }
    
        @media screen and (max-width: 480px) {
          .floating-button-container {
            bottom: 8%;
            right: 6%;
          }
          .floating-button-icon {
            width: 9vw;
            height: 9vw;
            max-width: 40px;
            max-height: 40px;
          }
        }
      `}</style>
          </div> */}
<>
        <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    top: 0,
    zIndex: 1000,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: isMobile ? "10px 3%" : "0px 5%",
    backgroundColor: "#fff",
    flexWrap: "wrap",
     borderBottom: "1px solid #ddd",
  }}
>

<div
  onClick={() => {
    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  }}
  style={{ cursor: "pointer" }}
>
  <img
    src={logo}
    alt="Logo"
    style={{
      maxWidth: isMobile ? "120px" : "150px",
      height: "auto",
      marginLeft: isMobile ? "-10px" : "-50px",
    }}
  />
</div>

   
           {/* Mobile Hamburger Icon */}
           {isMobile && (
             <button
               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
               style={{ background: "none", border: "none", cursor: "pointer" }}
             >
               <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
               </svg>
             </button>
           )}
   
           {/* Desktop/Tablet Menu */}
           {!isMobile && (
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "8px",
                 flexDirection: "row",
                 width: "auto",
                 backgroundColor: "transparent",
                 padding: "0",
               }}
             >
{["Products", "Partner", "Say Hello"].map((item, index) => (
        <div
          key={index}
          style={{ position: "relative", width: "auto" }}
          onMouseEnter={() => {
            setHoveredItem(item);
            if (item === "Products") setShowDropdown(true);
          }}
          onMouseLeave={() => {
            setHoveredItem(null);
            if (item === "Products") setShowDropdown(false);
          }}
        >
          <div
            onClick={() => handleClick(item)}
            style={{
              fontSize: "clamp(12px, 2vw, 16px)",
              cursor: "pointer",
              fontWeight: "normal",
              backgroundColor:
                activeItem === item || hoveredItem === item
                  ? "#EAF3FF"
                  : "transparent",
              padding: "8px 16px",
              borderRadius: "20px",
              transition: "background-color 0.3s",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "flex-start",
            }}
          >
            {item}
            {item === "Products" && (
              <img
                src={down}
                alt="Down Arrow"
                style={{
                  width: "10px",
                  height: "7px",
                  transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              />
            )}
          </div>

          {item === "Products" && showDropdown && (
            <div
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
              style={{
                position: "fixed",
                top: 30,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 9999,
                marginTop: "20px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "24px",
                overflow: "hidden",
                width: "min(980px, 90vw)",
                maxWidth: "100%",
                padding: "16px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "16px",
                boxSizing: "border-box",
              }}
            >
              {dropdownItems.map((section, i) => (
                <div
                  key={i}
                  style={{
                    paddingRight:
                      i < dropdownItems.length - 1 ? "16px" : undefined,
                    borderRight:
                      i < dropdownItems.length - 1
                        ? "1px solid #E0E0E0"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      color: "#666",
                      fontWeight: 600,
                      marginBottom: 12,
                      textTransform: "uppercase",
                      fontSize: 12,
                    }}
                  >
                    {section.title}
                  </div>

                  {section.items.map((product, j) => (
                    <div
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                        padding: "8px",
                        cursor: "pointer",
                        marginBottom: 8,
                        borderRadius: 8,
                        transition: "background-color 0.3s ease",
                      }}
                      onClick={() => {
                        if (product.name === "Gate") navigate("/gate");
                        else if (product.name === "MeetQ") navigate("/meetq");
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#F0F8FF";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "#004aad";
                        if (arrow) {
                          arrow.style.filter =
                            "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                          arrow.style.transform = "translateX(4px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        const name = e.currentTarget.querySelector(
                          ".product-name"
                        );
                        const arrow = e.currentTarget.querySelector(".arrow-icon");
                        if (name) name.style.color = "inherit";
                        if (arrow) {
                          arrow.style.filter = "none";
                          arrow.style.transform = "translateX(0)";
                        }
                      }}
                    >
                      <img
                        src={product.icon}
                        alt={product.name}
                        style={{ width: 20, height: 20 }}
                      />
                      <div>
                        <div
                          className="product-name"
                          style={{
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            transition: "color 0.3s ease",
                            fontSize: 13,
                          }}
                        >
                          {product.name}
                          <img
                            className="arrow-icon"
                            src={nr}
                            alt="arrow"
                            style={{
                              marginLeft: 4,
                              width: 16,
                              height: 16,
                              transition: "filter 0.3s ease, transform 0.3s ease",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            color: "#666",
                            fontSize: 12,
                            textAlign: "left",
                            lineHeight: 1.4,
                          }}
                        >
                          {product.description}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

   
               <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                 <button
  onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
  className="login-button"
  style={{
    padding: "10px 20px",
    borderRadius: "20px",
    border: "1px solid #004aad",
    backgroundColor: "#fff",
    color: "#004aad",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s",
  }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
>
  Login
</button>

                 <button
                   onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                   className="register-button"
                   style={{
                     padding: "10px 20px",
                     borderRadius: "20px",
                     border: "none",
                     backgroundColor: "#004aad",
                     color: "#fff",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "16px",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                 >
                   Register
                 </button>
               </div>
             </div>
           )}
         </div>
   
         {/* Mobile Menu */}
         {isMobile && isMobileMenuOpen && (
           <div
             style={{
               position: "fixed",
               top: 0,
               left: 0,
               width: "100%",
               height: "100%",
               backgroundColor: "#fff",
               padding: "20px",
               overflowY: "auto",
               zIndex: 1001,
               boxSizing: "border-box",
               fontFamily: "Epilogue, sans-serif",
             }}
           >
             {/* Header with Logo and Close Button */}
             <div
               style={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
                 marginBottom: "20px",
               }}
             >
               <Link to="/">
  <img
    src={logo}
    alt="Logo"
    style={{ width: "120px", height: "auto", cursor: "pointer" }}
  />
</Link>
               <button
                 onClick={() => setIsMobileMenuOpen(false)}
                 style={{ background: "none", border: "none", cursor: "pointer" }}
               >
                 <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                 </svg>
               </button>
             </div>
   
             {/* Navigation Items */}
             {["Products", "Partner", "Say Hello"].map((item, index) => (
               <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                 {item === "Products" ? (
                   <>
                     <div
                       onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                       style={{
                         fontSize: "16px",
                         cursor: "pointer",
                         fontWeight: "600",
                         color: "#004aad",
                         padding: "12px",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                         borderRadius: "8px",
                         transition: "background-color 0.3s",
                         textAlign: "center",
                       }}
                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                     >
                       Products
                       <img
                         src={down}
                         alt="Arrow"
                         style={{
                           width: "10px",
                           height: "7px",
                           transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                           transition: "transform 0.3s",
                         }}
                       />
                     </div>
                     {mobileProductsOpen && (
                       <div
                         style={{
                           marginTop: "12px",
                           padding: "16px",
                           backgroundColor: "#F9FAFB",
                           borderRadius: "12px",
                           display: "flex",
                           flexDirection: "column",
                           gap: "16px",
                           maxWidth: "100%",
                           overflow: "auto",
                           boxSizing: "border-box",
                           justifyContent: "center",
                           alignItems: "center",
                           textAlign: "center",
                         }}
                       >
                         {dropdownItems.map((section, i) => (
                           <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                             <div
                               style={{
                                 color: "#666",
                                 fontWeight: "600",
                                 textTransform: "uppercase",
                                 fontSize: "12px",
                                 marginBottom: "8px",
                               }}
                             >
                               {section.title}
                             </div>
                             {section.items.map((product, j) => (
                               <div
                                 key={j}
                                 style={{
                                   display: "flex",
                                   flexDirection: "column",
                                   alignItems: "center",
                                   gap: "8px",
                                   padding: "8px",
                                   cursor: "pointer",
                                   borderRadius: "8px",
                                   transition: "background-color 0.3s ease",
                                   maxWidth: "100%",
                                 }}
                                 onClick={() => {
                                   if (product.name === "Gate") navigate("/gate");
                                   else if (product.name === "MeetQ") navigate("/meetq");
                                   setIsMobileMenuOpen(false);
                                 }}
                                 onMouseEnter={(e) => {
                                   e.currentTarget.style.backgroundColor = "#F0F8FF";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "#004aad";
                                 }}
                                 onMouseLeave={(e) => {
                                   e.currentTarget.style.backgroundColor = "transparent";
                                   const name = e.currentTarget.querySelector(".product-name");
                                   name.style.color = "inherit";
                                 }}
                               >
                                 <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                 <div style={{ flex: 1, overflow: "hidden" }}>
                                   <div
                                     className="product-name"
                                     style={{
                                       fontWeight: "600",
                                       fontSize: "14px",
                                       transition: "color 0.3s ease",
                                       whiteSpace: "normal",
                                       overflow: "hidden",
                                       textOverflow: "ellipsis",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.name}
                                   </div>
                                   <div
                                     style={{
                                       color: "#666",
                                       fontSize: "12px",
                                       lineHeight: "1.4",
                                       overflowWrap: "break-word",
                                       textAlign: "center",
                                     }}
                                   >
                                     {product.description}
                                   </div>
                                 </div>
                               </div>
                             ))}
                           </div>
                         ))}
                         <a
                           href="#"
                           style={{
                             color: "#004aad",
                             fontWeight: "600",
                             fontSize: "14px",
                             textDecoration: "none",
                             display: "inline-flex",
                             alignItems: "center",
                             padding: "8px",
                           }}
                           onClick={() => setIsMobileMenuOpen(false)}
                         >
                           Explore all products
                           <img
                             src={right}
                             alt="arrow"
                             style={{
                               marginLeft: "4px",
                               width: "16px",
                               height: "16px",
                               verticalAlign: "middle",
                             }}
                           />
                         </a>
                       </div>
                     )}
                   </>
                 ) : (
                   <div
                     onClick={() => {
                       handleClick(item);
                       setIsMobileMenuOpen(false);
                     }}
                     style={{
                       fontSize: "16px",
                       cursor: "pointer",
                       fontWeight: "600",
                       color: "#004aad",
                       padding: "12px",
                       borderRadius: "8px",
                       transition: "background-color 0.3s",
                       textAlign: "center",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                   >
                     {item}
                   </div>
                 )}
               </div>
             ))}
   
             {/* Buttons */}
             <div
               style={{
                 display: "flex",
                 flexDirection: "column",
                 gap: "12px",
                 width: "100%",
                 marginTop: "20px",
               }}
             >
               <button
                 onClick={() => {
                   window.location.href = "http://app.mawalog.com/login";
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "1px solid #004aad",
                   backgroundColor: "#fff",
                   color: "#004aad",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
               >
                 Login
               </button>
               <button
                 onClick={() => {
                   window.open("https://app.mawalog.com/register", "_blank");
                   setIsMobileMenuOpen(false);
                 }}
                 style={{
                   padding: "8px 16px",
                   borderRadius: "20px",
                   border: "none",
                   backgroundColor: "#004aad",
                   color: "#fff",
                   fontWeight: "bold",
                   cursor: "pointer",
                   fontSize: "14px",
                   width: "100%",
                   transition: "background-color 0.3s",
                 }}
                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
               >
                 Register
               </button>
             </div>
           </div>
         )}
   
         {/* Media Queries for Tablet Button Size */}
         <style>
           {`
             @media (min-width: 769px) and (max-width: 1024px) {
               .login-button, .register-button {
                 padding: 8px 16px !important;
                 font-size: 14px !important;
               }
             }
           `}
         </style>
       </>
       <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "5px clamp(16px, 4vw, 30px)",
            fontFamily: "sans-serif",
            backgroundColor: "#fff",
            position: "sticky",
            top: 0,
            zIndex: 999,
          }}
        >
          {/* Left: Logo + Nav in one block */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "clamp(20px, 5vw, 40px)",
              flexWrap: "wrap",
              flexGrow: 1, // fill available space
              minWidth: 0,
            }}
          >
            {/* Logo */}
          <a href="/gate" style={{ textDecoration: "none" }}>
           <div
             style={{
               display: "flex",
               alignItems: "center",
               gap: "8px",
               cursor: "pointer",
             }}
           >
             <img
               src={gate}
               alt="Gate Logo"
               style={{ width: "32px", height: "32px", marginBottom: "10px" }}
             />
             <span
               style={{
                 fontSize: "clamp(24px, 5vw, 30px)",
                 fontWeight: 800,
                 color: "#1A1A1A",
                 whiteSpace: "nowrap",
                 marginBottom: "10px",
               }}
             >
               Gate
             </span>
           </div>
         </a>
        
            {/* Nav Links */}
            <nav
              style={{
                display: "flex",
                gap: "clamp(12px, 4vw, 30px)",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
             
              {[
       { href: "/industries", text: "Industries Served" },
       { href: "/features", text: "Features" },
       { href: "/price", text: "Pricing" },
       { href: "/faq", text: "FAQ" },
     ].map(({ href, text }) => (
       <a
         key={text}
         href={href}
         style={{
           fontFamily: "Epilogue",
           fontSize: "clamp(13px, 2.2vw, 16px)",
           fontWeight: 400,
           textDecoration: "none",
           color: text === "Features" ? "#2C8C53" : "#1A1A1A",
           cursor: "pointer",
           lineHeight: 1.4,
           paddingBottom: text === "Features" ? "4px" : "0",
           borderBottom:
             text === "Features" ? "2px solid #2C8C53" : "none",
         }}
       >
         {text}
       </a>
     ))}
     
            </nav>
          </div>
        
          {/* Right: Button stays aligned right */}
          <div
            style={{
              flex: "0 0 auto",
              marginLeft: "auto", // pushes it to the right even if wrapped
              marginTop: "10px", // space if it wraps below nav
            }}
          >
            <button
              onClick={() =>
                window.open(
                  "https://outlook.office365.com/book/MawalogOne@lenteratechno.onmicrosoft.com/",
                  "_blank"
                )
              }
              style={{
                backgroundColor: "#2E8B57",
                color: "#fff",
                padding: "clamp(8px, 1.5vw, 12px) clamp(16px, 6vw, 20px)",
                fontSize: "clamp(12px, 2vw, 14px)",
                fontWeight: 600,
                borderRadius: 9999,
                border: "none",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                whiteSpace: "nowrap",
              }}
            >
              Book a Demo
              <img
                src={bbb}
                alt="arrow"
                style={{
                  width: "clamp(14px, 3.5vw, 18px)",
                  height: "clamp(14px, 3.5vw, 18px)",
                }}
              />
            </button>
        
            
          </div>
        </div>




<>
  <style>
    {`
      /* ─── Desktop Wide (≥1440px) ─── */
      @media (min-width: 1440px) {
        .gate-desc {
          font-size: 13px !important;
          padding: 0 24px !important;
          margin-top: 24px !important;
        }
      }

      /* ─── Laptop (1025px – 1439px) ─── */
      @media (min-width: 1025px) and (max-width: 1439px) {
        .gate-desc {
          font-size: 12.5px !important;
          padding: 0 20px !important;
          margin-top: 22px !important;
        }
      }

      /* ─── Tablet (769px – 1024px) ─── */
      @media (max-width: 1024px) and (min-width: 769px) {
        .gate-desc {
          font-size: 12px !important;
          padding: 0 16px !important;
          margin-top: 20px !important;
        }
      }

      /* ─── Mobile / Large Phones (481px – 768px) ─── */
      @media (max-width: 768px) {
        .gate-desc {
          font-size: 11px !important;
          padding: 0 12px !important;
          margin-top: 16px !important;
        }
      }

      /* ─── Small Phones (≤ 480px) ─── */
      @media (max-width: 480px) {
        .gate-desc {
          font-size: 10.5px !important;
          line-height: 1.5 !important;
        }
      }
    `}
  </style>

  <div
    className="gate-desc"
    style={{
      fontFamily: "Epilogue",
      fontSize: "clamp(12px, 1.2vw, 12px)",
      fontWeight: "400",
      textAlign: "center",
      color: "#1E1E1E",
      lineHeight: "1.6",
      marginTop: "20px",
      padding: "0 20px",
      maxWidth: "900px",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    The Gate feature provides real-time tracking and monitoring, ensuring
    secure and efficient <br />
    handling of items. With advanced monitoring tools, the Gate feature
    improves transparency and <br />
    accountability in logistics operations.
  </div>
</>


 <>
  <style>
    {`
      @keyframes float {
        0%   { transform: translateY(0); }
        50%  { transform: translateY(-10px); }
        100% { transform: translateY(0); }
      }

      @media (min-width: 769px) {
        .float-animate { animation: float 3s ease-in-out infinite; }
      }

      .cards-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 40px;
        padding: 40px clamp(20px, 5vw, 60px);
        font-family: Epilogue, sans-serif;
      }
      .card        { max-width: 320px; text-align: center; }
      .card img    {
        width: auto;
        max-width: 80%;
        max-height: 220px;
        display: block;
        border-radius: 20px;
        margin: 0 auto;
        object-fit: contain;
      }
      .card h3 { font-size: 20px; }
      .card p  { font-size: 14px; }

      /* Laptop / large tablets (≤1200 px) */
      @media (max-width: 1200px) {
        .cards-wrap { gap: 32px !important; padding: 35px clamp(18px,4vw,50px) !important; }
        .card       { max-width: 300px !important; }
        .card img   { max-width: 82% !important; max-height: 200px !important; }
      }

      /* Tablets / large phones (≤768 px) */
      @media (max-width: 768px) {
        .cards-wrap { gap: 28px !important; padding: 30px clamp(14px,6vw,40px) !important; }
        .card h3    { font-size: 18px !important; }
        .card p     { font-size: 13px !important; }
        .card img   {
          max-width: 70% !important;
          max-height: 160px !important;
          margin-left: auto !important;   /* ⬅️ Center horizontally */
          margin-right: auto !important;  /* ⬅️ Center horizontally */
        }
      }

      /* Small phones (≤480 px) */
      @media (max-width: 480px) {
        .cards-wrap { gap: 24px !important; padding: 25px 12px !important; }
        .card       { max-width: 100% !important; }
        .card h3    { font-size: 17px !important; }
        .card p     { font-size: 12px !important; }
        .card img   {
          max-width: 60% !important;
          max-height: 140px !important;
          margin-left: auto !important;   /* ⬅️ Center horizontally */
          margin-right: auto !important;  /* ⬅️ Center horizontally */
        }
      }
    `}
  </style>

  {/* ─── Cards ─── */}
  <div className="cards-wrap">
    {/* Card 1 */}
    <div className="card float-animate" style={{ animationDelay: "0s" }}>
      <img src={user} alt="User Experience" style={{ marginTop: "-20px" }} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }}>
        <h3 style={{ color: "#1E1E1E", marginBottom: "10px", fontWeight: 700 }}>User Experience</h3>
        <p style={{ color: "#7D8A9C", lineHeight: "1.6" }}>
          Focused features, such as rapid loading times, mobile responsiveness,
          intuitive design, and low friction during the conversion process.
        </p>
      </div>
    </div>

    {/* Card 2 */}
    <div className="card float-animate" style={{ animationDelay: "0.3s" }}>
      <img src={dd} alt="Data Analytics" style={{ marginLeft: "20px" }} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10px" }}>
        <h3 style={{ color: "#1E1E1E", marginBottom: "10px", fontWeight: 700, marginRight: "20px" }}>Data Analytics</h3>
        <p style={{ color: "#7D8A9C", lineHeight: "1.6" }}>
          The Gate's features for tracking and analyzing data are critical for
          assessing performance and enhancing marketing campaigns.
        </p>
      </div>
    </div>

    {/* Card 3 */}
    <div className="card float-animate" style={{ animationDelay: "0.6s" }}>
      <img src={sec} alt="Security Compliance" style={{ width: "100%", marginLeft: "-30px" }} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }}>
        <h3 style={{ color: "#1E1E1E", marginBottom: "10px", fontWeight: 700 }}>Security Compliance</h3>
        <p style={{ color: "#7D8A9C", lineHeight: "1.6" }}>
          Elements that assure user information security and adherence to
          relevant legislation should not be disregarded.
        </p>
      </div>
    </div>
  </div>
</>


<>
  <div
    className="responsive-wrapper"
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "40px",
      maxWidth: "1100px",
      margin: "0 auto",
      background: "linear-gradient(90deg, #FBE798 0%, #F5F5F2 100%)",
      borderRadius: "24px",
      fontFamily: "Epilogue, sans-serif",
      gap: "40px",
      boxSizing: "border-box",
    }}
  >
    {/* Left Section */}
    <div
      className="responsive-left"
      style={{
        flex: "1 1 40%",
        minWidth: "200px",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: "clamp(24px, 3.5vw, 32px)",
          fontWeight: 700,
          color: "#1A1A1A",
          marginTop: "40px",
          marginLeft: "-20px",
          lineHeight: "1.3",
        }}
      >
        Self Digital <br /> Registration
      </div>
      <img
        src={laptop}
        alt="Digital Registration"
        style={{
          maxWidth: "100%",
          height: "200px",
          marginLeft: "50px",
          objectFit: "contain",
        }}
        className="hide-on-mobile-tablet"
      />
    </div>

    {/* Right Section - Cards */}
    <div
      className="responsive-right"
      style={{
        flex: "1 1 55%",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: "20px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {[
        {
          icon: p1,
          text: "Verification via phone number using One Time Password",
        },
        {
          icon: p2,
          text: "Verification via Face identification for quick Gate-in process",
        },
        {
          icon: p3,
          text: "Verify you via WhatsApp using get OTP in message to easy Gate in",
        },
      ].map((item, index) => (
        <div
          key={index}
          className={`card-${index}`}
          style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "20px",
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
            gridColumn: index === 2 ? "span 2" : "auto",
          }}
        >
          <img
            src={item.icon}
            alt="icon"
            style={{ width: "24px", height: "24px", marginTop: "2px" }}
          />
          <div
            style={{
              fontSize: "15px",
              fontWeight: "500",
              color: "#1A1A1A",
              lineHeight: "1.5",
            }}
          >
            {item.text}
          </div>
        </div>
      ))}
    </div>
  </div>

  <style>{`
    /* Hide image on tablet and mobile */
    @media (max-width: 1024px) {
      .hide-on-mobile-tablet {
        display: none !important;
      }
    }

    /* Stack sections on mobile */
    @media (max-width: 768px) {
      .responsive-wrapper {
        flex-direction: column !important;
        padding: 20px !important;
      }
      .responsive-left,
      .responsive-right {
        flex: 1 1 100% !important;
        width: 100% !important;
      }
      .responsive-left {
        flex-direction: column !important;
        margin: 0 !important;
      }

      /* Make grid 1 column on mobile */
      .responsive-right {
        display: grid !important;
        grid-template-columns: 1fr !important;
        gap: 16px !important;
      }

      /* Remove grid column spanning on last card */
      .responsive-right > div {
        grid-column: auto !important;
      }
    }
  `}</style>
</>




<>
  <div style={{ overflowX: "hidden" }}>
    {/* ────────── Main Flex Wrapper ────────── */}
    <div
      ref={sectionRef}
      className="entry-wrap"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "40px",
        padding: "40px",
        borderRadius: "20px",
        background: "#fff",
        fontFamily: "Epilogue",
        maxWidth: "1100px",
        margin: "0 auto",
        flexWrap: "wrap",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateX(0)" : "translateX(-50px)",
        transition: "opacity 0.6s ease, transform 0.6s ease",
        boxSizing: "border-box",
      }}
    >
      {/* Left Section */}
      <div className="entry-text" style={{ flex: "1 1 45%" }}>
        <h2
          style={{
            fontSize: "32px",
            fontWeight: 700,
            color: "#212121",
            marginBottom: "16px",
            lineHeight: 1.25,
          }}
        >
          Customizable Entry Form
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#4B4B4B",
            lineHeight: 1.6,
            marginBottom: "12px",
          }}
        >
          A customizable entry form is a flexible, mobile-responsive <br />
          solution that lets you add or remove fields, set custom labels, <br />
          choose input types, define required fields, and easily match <br />
          the design to your brand – making it ideal for contact forms, <br />
          surveys, applications, event registrations, and more.
        </p>
        <p
          style={{
            fontSize: "16px",
            color: "#4B4B4B",
            lineHeight: 1.6,
          }}
        >
          It simplifies data collection and ensures a smooth, user- <br />
          friendly experience across all devices.
        </p>
      </div>

      {/* Right Section – Image */}
      <div className="entry-imgbox" style={{ flex: "1 1 45%" }}>
        <img
          src={c1}
          alt="Customizable Entry Form Screenshot"
          className="responsive-image"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            borderRadius: "20px",
          }}
        />
      </div>
    </div>
  </div>

  {/* ────────── Responsive CSS ────────── */}
  <style>{`
    /* Laptop / large-tablet adjustments (≤ 1024 px) */
    @media (max-width: 1024px) {
      .entry-wrap {
        padding: 24px !important;
        gap: 24px !important;
        flex-direction: column !important;      /* stack sections */
        align-items: flex-start !important;
      }
      .entry-text,
      .entry-imgbox {
        flex: 1 1 100% !important;
        width: 100% !important;
      }
      .responsive-image {
        width: 100% !important;
        height: auto !important;
      }
    }

    /* Mobile (≤ 480 px) */
    @media (max-width: 480px) {
      .entry-wrap {
        padding: 16px !important;
        gap: 16px !important;
      }
      .entry-text h2 {
        font-size: 24px !important;
        line-height: 1.3 !important;
      }
      .entry-text p {
        font-size: 14px !important;
      }
    }
  `}</style>
</>

<>
  <div style={{ overflowX: "hidden" }}>
    {/* ────────── Main Flex Wrapper ────────── */}
    <div
      ref={sectionReff}
      className="alert-wrap"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "40px",
        padding: "40px",
        borderRadius: "20px",
        background: "#fff",
        fontFamily: "Epilogue, sans-serif",
        maxWidth: "1100px",
        margin: "0 auto",
        flexWrap: "wrap",
        opacity: inView ? 1 : 0,
        transform: inView ? "translateX(0)" : "translateX(100px)",
        transition: "opacity 0.6s ease, transform 0.6s ease",
        boxSizing: "border-box",
      }}
    >
      {/* Left – Image */}
      <div className="alert-imgbox" style={{ flex: "1 1 45%" }}>
        <img
          src={c2}
          alt="Notification illustration"
          className="responsive-image"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            borderRadius: "20px",
          }}
        />
      </div>

      {/* Right – Text */}
      <div className="alert-text" style={{ flex: "1 1 45%" }}>
        <h2
          style={{
            fontSize: "32px",
            fontWeight: 700,
            color: "#212121",
            marginBottom: "16px",
            lineHeight: 1.25,
          }}
        >
          WhatsApp, Email,<br />&amp; SMS alerts
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#4B4B4B",
            lineHeight: 1.6,
          }}
        >
          Our visitor-management application delivers real-time, customizable
          WhatsApp, email, and SMS alerts—ensuring hosts and administrators
          receive instant notifications at every stage of a guest’s check-in,
          visit, and departure.
        </p>
      </div>
    </div>
  </div>

  {/* ────────── Responsive CSS ────────── */}
  <style>{`
    /* Tablets & small laptops (≤ 1024 px) — stack vertically */
    @media (max-width: 1024px) {
      .alert-wrap {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 24px !important;
        padding: 24px !important;
      }
      .alert-text,
      .alert-imgbox {
        flex: 1 1 100% !important;
        width: 100% !important;
      }
      .responsive-image {
        width: 100% !important;
        height: auto !important;
      }
      .alert-text h2 { font-size: 28px !important; }
      .alert-text p  { font-size: 16px !important; }
    }

    /* Phones (≤ 480 px) — tighter padding & smaller fonts */
    @media (max-width: 480px) {
      .alert-wrap {
        padding: 16px !important;
        gap: 16px !important;
      }
      .alert-text h2 { font-size: 24px !important; line-height: 1.3 !important; }
      .alert-text p  { font-size: 14px !important; }
    }
  `}</style>
</>




<>
  <div style={{ overflowX: 'hidden' }}>
    <div
      ref={dashboardRef}
      className="dash-wrap"
      style={{
        transform: dashboardInView ? 'translateX(0)' : 'translateX(-100px)',
        opacity: dashboardInView ? 1 : 0,
        transition: 'transform .8s ease, opacity .8s ease',
      }}
    >
      {/* ── Text ── */}
      <div className="dash-text">
        <h2>Futuristic Dashboard</h2>
        <p>
          The visitor-management application features a futuristic dashboard
          designed with sleek visuals, real-time analytics, and intuitive
          controls — offering a centralized view of visitor activity,
          live check-in data, security alerts, and performance insights.
        </p>
      </div>

      {/* ── Image ── */}
      <div className="dash-imgbox">
        <img src={c3} alt="Futuristic dashboard UI" />
      </div>
    </div>
  </div>

  <style>{`
    /* ───────── Base (mobile-first) ───────── */
    .dash-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      gap: 24px;
      padding: 24px;
      margin: -40px auto 10px;  /* default margin (for larger screens) */
      width: 92%;
      max-width: 960px;
      border-radius: 20px;
      background: #fff;
      font-family: 'Epilogue', sans-serif;
      box-sizing: border-box;
    }

    .dash-text,
    .dash-imgbox {
      flex: 1 1 100%;
    }

    .dash-text h2 {
      font: 700 28px/1.25 'Epilogue', sans-serif;
      color: #212121;
      margin: 0 0 12px;
    }

    .dash-text p {
      font: 15px/1.6 'Epilogue', sans-serif;
      color: #4B4B4B;
    }

    .dash-imgbox img {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 20px;
    }

    /* ───────── Tablets / small laptops (≥ 768 px) ───────── */
    @media (min-width: 768px) {
      .dash-wrap {
        flex-wrap: nowrap;
        gap: 32px;
        padding: 32px;
      }

      .dash-text,
      .dash-imgbox {
        flex: 1 1 48%;
      }

      .dash-text h2 {
        font-size: 30px;
      }

      .dash-text p {
        font-size: 16px;
      }
    }

    /* ───────── Standard laptop / desktop (≥ 1024 px) ───────── */
    @media (min-width: 1024px) {
      .dash-wrap {
        gap: 40px;
        padding: 40px;
        max-width: 1100px;
      }

      .dash-text h2 {
        font-size: 32px;
      }
    }

    /* ───────── Large desktop / ultrawide (≥ 1440 px) ───────── */
    @media (min-width: 1440px) {
      .dash-wrap {
        gap: 48px;
        padding: 48px;
        max-width: 1260px;
      }

      .dash-text h2 {
        font-size: 34px;
      }

      .dash-text p {
        font-size: 17px;
      }
    }

    /* ───────── Mobile Fix: Push section down on smaller screens ───────── */
    @media (max-width: 767px) {
      .dash-wrap {
        margin: 20px auto 10px !important; /* override for mobile */
      }
    }
  `}</style>
</>










      <>
  <div
    style={{
      backgroundColor: "#222222",
      color: "white",
      padding: "40px",
      marginTop: "50px",
      fontFamily: "Epilogue",
    }}
  >
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
      className="responsive-container"
    >
      <div style={{ flex: "1 1 50%", minWidth: "300px" }} className="responsive-left">
        <h1
          style={{
            fontSize: "36px",
            fontWeight: "bold",
            marginBottom: "20px",
            lineHeight: 1.2,
          }}
        >
          What functionalities are <br /> offered by the Gate
        </h1>
      </div>
      <div
        style={{
          flex: "1 1 50%",
          minWidth: "300px",
          display: "flex",
          alignItems: "center",
        }}
        className="responsive-right"
      >
        <div
          style={{
            color: "#FFFFFF",
            fontSize: "14px",
            lineHeight: 1.6,
            marginLeft: "90px",
            fontFamily: "Epilogue",
          }}
        >
          We offer a wide range of opportunities for our users to improve
          their <br /> gate management systems and processes.
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)", // 4 columns
          gap: "20px",
          backgroundColor: "#0F0F0F",
          padding: "30px",
          borderRadius: "60px",
          marginTop: "30px",
          width: "100%",
          boxSizing: "border-box",
        }}
        className="responsive-grid"
      >
        {[
          { icon: g1, label: "System Monitoring" },
          { icon: g2, label: "Regular  Updates" },
          { icon: g3, label: "Security Management" },
          { icon: g4, label: "Fault  Resolution" },
          { icon: g5, label: "User Management" },
          { icon: g6, label: "Real Time Analytics" },
          { icon: g7, label: "Quick Reports" },
          { icon: g8, label: "Access Control System" },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#2C2C2C",
              padding: "20px 15px",
              borderRadius: "30px",
              gap: "20px",
            }}
            className="responsive-grid-item"
          >
            <div style={{ width: "36px", height: "36px", flexShrink: 0 }}>
              <img
                src={item.icon}
                alt={item.label}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
            <div style={{ fontSize: "16px", fontWeight: "500" }}>
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>

  <style>{`
    /* Tablet and below (<=1024px) */
    @media (max-width: 1024px) {
      .responsive-container {
        padding: 0 20px;
      }
      .responsive-left, .responsive-right {
        flex: 1 1 100% !important;
        min-width: 100% !important;
        margin-bottom: 20px;
      }
      .responsive-right > div {
        margin-left: 0 !important;
      }
      .responsive-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        padding: 20px !important;
        border-radius: 40px !important;
        gap: 15px !important;
      }
      .responsive-grid-item {
        padding: 15px !important;
        gap: 15px !important;
      }
    }

    /* Mobile (<=480px) */
    @media (max-width: 480px) {
      .responsive-container {
        padding: 0 16px;
      }
      h1 {
        font-size: 28px !important;
      }
      .responsive-right > div {
        font-size: 13px !important;
        line-height: 1.4 !important;
      }
      .responsive-grid {
        grid-template-columns: 1fr !important;
        padding: 16px !important;
        border-radius: 30px !important;
        gap: 12px !important;
      }
      .responsive-grid-item {
        padding: 12px !important;
        gap: 12px !important;
      }
      .responsive-grid-item > div:last-child {
        font-size: 14px !important;
      }
    }
  `}</style>
</>

      <>
  <div
    style={{
      fontFamily: "Epilogue",
      fontWeight: "600",
      fontSize: "clamp(24px, 3vw, 36px)",
      textAlign: "center",
      lineHeight: "1.3",
      marginTop: "60px",
      color: "#212129",
      padding: "0 20px",
    }}
    className="responsive-text"
  >
    Digital Gate pass systems are <br /> transforming various industries
  </div>

  <style>{`
    @media (max-width: 768px) {
      .responsive-text {
        padding: 0 15px;
        line-height: 1.25;
      }
    }
    @media (max-width: 480px) {
      .responsive-text {
        padding: 0 10px;
        line-height: 1.2;
        font-size: clamp(20px, 4vw, 28px);
      }
    }
  `}</style>
</>


   <div style={{ padding: "60px 0 100px 0" }}>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "30px",
      width: "100%",
    }}
    className="cards-container"
  >
    {cardData.map((card, index) => (
      <div
        key={index}
        style={{
          backgroundColor: "#D2FADC",
          borderRadius: "25px",
          padding: "clamp(20px, 4vw, 40px)",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "30px",
          border: "1.5px solid #A3DEB6",
          width: "90%",
          maxWidth: "1000px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
        className="card-item"
      >
        <div style={{ flex: "1 1 300px", minWidth: "250px" }}>
          <h2
            style={{
              fontSize: "clamp(20px, 2.2vw, 28px)",
              fontWeight: "600",
              marginBottom: "20px",
              color: "#212129",
              fontFamily: "Epilogue",
            }}
          >
            {card.title}
          </h2>
          <p
            style={{
              fontSize: "clamp(12px, 1.2vw, 14px)",
              lineHeight: "1.6",
              color: "#212129",
              fontFamily: "Epilogue",
            }}
          >
            {card.description}
          </p>
        </div>
        <div style={{ flexShrink: 0 }}>
          <img
            src={card.image}
            alt={card.title}
            style={{
              width: "clamp(250px, 30vw, 330px)",
              height: "auto",
              borderRadius: "30px",
              objectFit: "cover",
            }}
            className="card-image"
          />
        </div>
      </div>
    ))}
  </div>

  <style>{`
    /* Tablets and smaller laptops */
    @media (max-width: 1024px) {
      .card-item {
        flex-wrap: nowrap !important;
        padding: 20px !important;
        gap: 20px !important;
      }
      .card-item > div:first-child {
        flex: 1 1 60% !important;
        min-width: unset !important;
      }
      .card-image {
        width: 35vw !important;
        max-width: 280px;
      }
    }

    /* Mobile phones */
    @media (max-width: 480px) {
      .card-item {
        flex-direction: column !important;
        align-items: center !important;
        padding: 15px !important;
        gap: 15px !important;
      }
      .card-item > div:first-child {
        flex: 1 1 100% !important;
        min-width: unset !important;
        text-align: center;
      }
      .card-image {
        width: 90vw !important;
        max-width: none;
        border-radius: 20px !important;
      }
      h2 {
        font-size: 22px !important;
      }
      p {
        font-size: 14px !important;
      }
    }
  `}</style>
</div>



      <div
      style={{
        fontFamily: "Epilogue, sans-serif",
        maxWidth: "1000px",
        margin: "0 auto",
        marginTop: isMobileOrTablet ? "20px" : "50px",
        padding: isMobileOrTablet ? "30px 15px" : "60px 20px",
        border: "1px solid #e0e0e0",
        borderRadius: "16px",
        marginBottom: "60px", // 👈 Prevents touching the next section
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          marginBottom: isMobileOrTablet ? "20px" : "40px",
          gap: isMobileOrTablet ? "10px" : undefined,
        }}
      >
        <div
          style={{
            flex: "1 1 300px",
            fontSize: isMobileOrTablet ? "24px" : "32px",
            fontWeight: "600",
            color: "#1A1A1A",
            marginBottom: isMobileOrTablet ? "10px" : "20px",
          }}
        >
          Download the <br />
          Gate App
        </div>
        <div
          style={{
            flex: "2 1 400px",
            fontSize: isMobileOrTablet ? "12px" : "14px",
            color: "#555",
            lineHeight: "1.6",
          }}
        >
          Stay ahead in evolving business landscapes with agile communication
          strategies that enable quick adaptation, foster resilience, and keep
          your organization aligned, informed, and ready to seize new
          opportunities.
        </div>
      </div>
    
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: isMobileOrTablet ? "10px" : "20px",
        }}
      >
        {/* Android */}
        <a
          href="https://play.google.com/store/apps/details?id=com.mawalog.gate"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit", display: "block" }}
        >
          <div
            style={{
              backgroundColor: isHovered ? "#E6FFEE" : "#f9f9f9",
              borderRadius: "12px",
              padding: isMobileOrTablet ? "12px" : "24px",
              textAlign: "left",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
              <img
                src={isHovered ? androidgreen : android}
                alt="android"
                style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
              />
            </div>
    
            <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
              Mobile Phone/ Tablet
            </div>
    
            <div
              style={{
                fontSize: isMobileOrTablet ? "14px" : "18px",
                fontWeight: "600",
                color: isHovered ? "#22A45D" : "#1A1A1A",
                marginBottom: "8px",
                transition: "color 0.3s ease",
              }}
            >
              Android
            </div>
    
            <div
              style={{
                fontSize: isMobileOrTablet ? "11px" : "13px",
                color: "#555",
                marginBottom: isMobileOrTablet ? "8px" : "16px",
                lineHeight: "1.2",
              }}
            >
              Click on the play store logo for navigate to the download page
            </div>
    
            <img src={playStore} alt="Google Play" style={{ height: "40px" }} />
          </div>
        </a>
    
        {/* iOS */}
        <a
          href="https://apps.apple.com/us/app/gate-m/id6477543461"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit", display: "block" }}
        >
          <div
            style={{
              backgroundColor: isHovered1 ? "#E6FFEE" : "#f9f9f9",
              borderRadius: "12px",
              padding: isMobileOrTablet ? "12px" : "24px",
              textAlign: "left",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={() => setIsHovered1(true)}
            onMouseLeave={() => setIsHovered1(false)}
          >
            <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
              <img
                src={isHovered1 ? iosgreen : ios}
                alt="ios"
                style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
              />
            </div>
    
            <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
              Mobile Phone/ Tablet
            </div>
    
            <div
              style={{
                fontSize: isMobileOrTablet ? "14px" : "18px",
                fontWeight: "600",
                color: isHovered1 ? "#22A45D" : "#1A1A1A",
                marginBottom: "8px",
                transition: "color 0.3s ease",
              }}
            >
              iOS
            </div>
    
            <div
              style={{
                fontSize: isMobileOrTablet ? "11px" : "13px",
                color: "#555",
                marginBottom: isMobileOrTablet ? "8px" : "16px",
                lineHeight: "1.2",
              }}
            >
              Click on the app store logo for navigate to the download page
            </div>
    
            <img src={appStore} alt="App Store" style={{ height: "40px" }} />
          </div>
        </a>
    
        {/* PC / Mac */}
        <a
          href="https://s3.ap-south-1.amazonaws.com/gate.mawalog.com/apps/Gate.exe"
          download
          style={{ textDecoration: "none", color: "inherit", display: "block" }}
        >
          <div
            style={{
              backgroundColor: isHovered2 ? "#E6FFEE" : "#f9f9f9",
              borderRadius: "12px",
              padding: isMobileOrTablet ? "12px" : "24px",
              textAlign: "left",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={() => setIsHovered2(true)}
            onMouseLeave={() => setIsHovered2(false)}
          >
            <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
              <img
                src={isHovered2 ? pcgreen : pc}
                alt="desktop"
                style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
              />
            </div>
    
            <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
              Desktop
            </div>
    
            <div
              style={{
                fontSize: isMobileOrTablet ? "14px" : "18px",
                fontWeight: "600",
                color: isHovered2 ? "#22A45D" : "#1A1A1A",
                marginBottom: "8px",
                transition: "color 0.3s ease",
              }}
            >
              PC / MAC
            </div>
    
            <div
              style={{
                fontSize: isMobileOrTablet ? "11px" : "13px",
                color: "#555",
                marginBottom: isMobileOrTablet ? "8px" : "16px",
                lineHeight: "1.2",
              }}
            >
              Click on the download button to initiate the downloading process
            </div>
    
            <button
              style={{
                backgroundColor: "#22A45D",
                color: "#fff",
                border: "none",
                borderRadius: "25px",
                padding: "10px 24px",
                fontSize: "14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={load}
                alt="Download"
                style={{ width: "18px", height: "18px", objectFit: "contain" }}
              />
              Download
            </button>
          </div>
        </a>
      </div>
    </div>
         {/* <div
                       style={{
                         fontFamily: "Epilogue",
                         lineHeight: "1.4",
                         padding: "clamp(30px, 5vw, 60px)",
                         marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
                       }}
                     >
                       <div
                         style={{
                           maxWidth: "clamp(800px, 90vw, 1200px)",
                           margin: "0 auto",
                         }}
                       >
                         <div
                           style={{
                             display: "flex",
                             flexDirection: "column",
                             alignItems: "center",
                           }}
                         >
                           <div
                             style={{
                               color: "#181835",
                               fontSize: "clamp(18px, 2.5vw, 22px)",
                               fontWeight: "bold",
                               paddingLeft: screenWidth <= 1440 ? "clamp(50px, 10vw, 110px)" : "clamp(100px, 12vw, 170px)",
                               alignSelf: "flex-start",
                             }}
                           >
                             Compliance of our company
                           </div>
                           <div
                             style={{
                               display: "flex",
                               justifyContent: "center",
                               gap: "clamp(10px, 2vw, 15px)",
                               marginTop: "clamp(15px, 2vw, 20px)",
                               flexWrap: "wrap",
                             }}
                           >
                             {complianceData.slice(0, 3).map((item, index) => (
                               <div
                                 key={index}
                                 style={{
                                   display: "flex",
                                   alignItems: "center",
                                   backgroundColor: "#F4F7FF",
                                   width: "clamp(200px, 30vw, 270px)",
                                   height: "clamp(35px, 5vw, 40px)",
                                   padding: "clamp(4px, 1vw, 5px)",
                                   borderRadius: "30px",
                                   justifyContent: "space-between",
                                   cursor: "pointer",
                                   transition: "background-color 0.3s, transform 0.3s ease",
                                   marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                                 }}
                                 onMouseEnter={(e) => {
                                   e.currentTarget.style.backgroundColor = "#EDF4FF";
                                   e.currentTarget.style.transform = "scale(1.03)";
                                 }}
                                 onMouseLeave={(e) => {
                                   e.currentTarget.style.backgroundColor = "#F4F7FF";
                                   e.currentTarget.style.transform = "scale(1)";
                                 }}
                               >
                                 <div style={{ display: "flex", alignItems: "center" }}>
                                   <div
                                     style={{
                                       borderRadius: "50%",
                                       padding: "clamp(8px, 1.5vw, 10px)",
                                       marginRight: "clamp(8px, 1.5vw, 12px)",
                                     }}
                                   >
                                     <img
                                       src={item.icon}
                                       alt={item.title}
                                       style={{
                                         width: "clamp(30px, 4vw, 40px)",
                                         height: "clamp(30px, 4vw, 40px)",
                                       }}
                                     />
                                   </div>
                                   <span
                                     style={{
                                       color: "#181835",
                                       fontSize: "clamp(10px, 1.5vw, 12px)",
                                       marginRight: "-10px",
                                     }}
                                   >
                                     {item.title}
                                   </span>
                                 </div>
                                 <img
                                   src={riarr}
                                   alt="Arrow"
                                   style={{
                                     width: "clamp(14px, 2vw, 18px)",
                                     height: "clamp(14px, 2vw, 18px)",
                                   }}
                                 />
                               </div>
                             ))}
                           </div>
                         </div>
                         <div
                           style={{
                             display: "flex",
                             justifyContent: "center",
                             gap: "clamp(10px, 2vw, 15px)",
                             marginTop: "clamp(15px, 2vw, 20px)",
                             flexWrap: "wrap",
                             marginRight: screenWidth <= 1024 ? "clamp(5px, 2vw, 10px)" : "clamp(100px, 20vw, 290px)",
                           }}
                         >
                           {complianceData.slice(3, 5).map((item, index) => (
                             <div
                               key={index}
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 backgroundColor: "#F4F7FF",
                                 width: "clamp(200px, 30vw, 270px)",
                                 height: "clamp(35px, 5vw, 40px)",
                                 padding: "clamp(4px, 1vw, 5px)",
                                 borderRadius: "30px",
                                 justifyContent: "space-between",
                                 cursor: "pointer",
                                 transition: "background-color 0.3s, transform 0.3s ease",
                                 marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                               }}
                               onMouseEnter={(e) => {
                                 e.currentTarget.style.backgroundColor = "#EDF4FF";
                                 e.currentTarget.style.transform = "scale(1.03)";
                               }}
                               onMouseLeave={(e) => {
                                 e.currentTarget.style.backgroundColor = "#F4F7FF";
                                 e.currentTarget.style.transform = "scale(1)";
                               }}
                             >
                               <div style={{ display: "flex", alignItems: "center" }}>
                                 <div
                                   style={{
                                     borderRadius: "50%",
                                     padding: "clamp(8px, 1.5vw, 10px)",
                                     marginRight: "clamp(8px, 1.5vw, 12px)",
                                   }}
                                 >
                                   <img
                                     src={item.icon}
                                     alt={item.title}
                                     style={{
                                       width: "clamp(30px, 4vw, 40px)",
                                       height: "clamp(30px, 4vw, 40px)",
                                     }}
                                   />
                                 </div>
                                 <span
                                   style={{
                                     color: "#181835",
                                     fontSize: "clamp(10px, 1.5vw, 12px)",
                                     marginRight: "-10px",
                                   }}
                                 >
                                   {item.title}
                                 </span>
                               </div>
                               <img
                                 src={riarr}
                                 alt="Arrow"
                                 style={{
                                   width: "clamp(14px, 2vw, 18px)",
                                   height: "clamp(14px, 2vw, 18px)",
                                 }}
                               />
                             </div>
                           ))}
                         </div>
                       </div>
                     </div> */}
      
          <div
                     style={{
                       fontFamily: "Epilogue",
                       lineHeight: "1.4",
                       display: "flex",
                       alignItems: "center",
                       marginTop: "-20px",
                       justifyContent: "center",
                       backgroundColor: "#2C8C53",
                       padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
                       color: "#fff",
                     }}
                     className="newsletter-section"
                   >
                     <div
                       style={{
                         marginRight: "clamp(20px, 3vw, 40px)",
                         marginBottom: "clamp(16px, 2vw, 20px)",
                       }}
                     >
                       <img
                         src={newsgreen}
                         alt="Newsletter"
                         style={{
                           width: "clamp(150px, 20vw, 200px)",
                           height: "clamp(120px, 15vw, 170px)",
                           animation: "floatImage 3s ease-in-out infinite",
                         }}
                       />
                     </div>
             
                     <style>
                       {`
                   @keyframes floatImage {
                     0% { transform: translateY(0); }
                     50% { transform: translateY(-10px); }
                     100% { transform: translateY(0); }
                   }
             
                   @media (max-width: 480px) {
                     .newsletter-section {
                       flex-direction: column;
                       text-align: center;
                       padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
                     }
                     .newsletter-section > div:first-child {
                       margin-right: 0;
                       margin-bottom: clamp(16px, 2vw, 20px);
                     }
                     .newsletter-section h2,
                     .newsletter-section p,
                     .newsletter-section > div > div,
                     .newsletter-section > div > div:last-child {
                       margin-left: 0;
                     }
                     .newsletter-section .newsletter-input {
                       min-width: clamp(200px, 80vw, 260px);
                     }
                     .newsletter-section button {
                     
                       display: block;
                     }
                   }
                 `}
                     </style>
             
                        <div className="newsletter-content">
          {/* Title and Paragraph */}
          <>
            <style>
              {`
      .newsletter-text {
        font-family: Epilogue;
        line-height: 1.4;
        font-size: 22px;
        margin-bottom: 10px;
        margin-left: 60px;
      }

      @media (max-width: 1024px) {
        .newsletter-text {
          font-size: 20px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-text {
          font-size: 18px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-text {
          font-size: 16px;
          margin-left: 30px;
        }
      }
    `}
            </style>

            <div className="newsletter-text">Subscribe to our Newsletter!</div>
          </>

          <>
            <style>
              {`
      .newsletter-description {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: start;
        margin-left: 60px;
        max-width: 100%;
        box-sizing: border-box;
      }

      @media (max-width: 1024px) {
        .newsletter-description {
          font-size: 13px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-description {
          font-size: 12.5px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-description {
          font-size: 9px; /* reduced more for small screens */
          text-align: center;
      
        }
      }
    `}
            </style>

            <div className="newsletter-description">
              Stay updated with our latest news, offers, and insights! Subscribe{" "}
              <br />
              for exclusive updates delivered straight to your inbox.
            </div>
          </>

          
        <>
  <style>
    {`
      .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 10px auto; /* center aligned */
        flex-wrap: nowrap;
      }

      .email-input {
        padding: 14px 16px 14px 48px;
        border-radius: 10px;
        border: 1px solid #9FCAFF;
        outline: none;
        background-color:#1C6539;
        color: #fff;
        flex: 1;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
      }

      .email-icon {
        position: absolute;
        left: 16px;
        width: 20px;
        height: 20px;
      }

      /* Optional: Keep consistent appearance on all devices */
      @media (max-width: 480px) {
        .email-input {
          padding: 12px 12px 12px 44px;
          font-size: 14px;
        }
      }
    `}
  </style>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
    }}
  >
    <div className="input-wrapper">
      <img src={mail} alt="Email Icon" className="email-icon" />
      <input
        type="email"
        value={email}
        placeholder="sample@gmail.com"
        className="email-input"
        onChange={handleChange}
      />
    </div>
  </div>
</>


         
          <>
            <style>{`
        .captcha-container {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          border-radius: 20px !important;    
          gap: 8px !important;
          flex-wrap: wrap !important;
        }
      .captcha-box {
  width: 60px !important;
  height: 40px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important; /* Add this to clip canvas overflow */
}

#captchaCanvas {
  border-radius: 20px !important;
}
        .captcha-input {
          padding:10px 1px!important;
          border-radius:8px!important;
          border:1px solid #ccc!important;
          outline:none!important;
          min-width:120px!important;
          background:#1C6539!important;
          color:#fff!important;
        }
        .subscribe-button {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#1C6539!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
        @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
        @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
      `}</style>

            <div className="captcha-container">
              <div className="captcha-box">
                <canvas
                  ref={canvasRef}
                  id="captchaCanvas"
                  width={60}
                  height={40}
                />
              </div>

              <button
                onClick={handleReload}
                style={{
                  background: "#1C6539",
                  color: "#fff",
                  border: "none",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Your reload SVG icon here */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>

              <input
                type="text"
                placeholder="Enter captcha"
                value={userCaptcha}
                onChange={(e) => setUserCaptcha(e.target.value)}
                className="captcha-input"
              />

              <button className="subscribe-button" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
          </>

          {/* Note */}
          <div
            style={{
              fontSize: "12px",
              marginTop: "10px",
              color: "#fff",
              marginLeft:
                window.innerWidth <= 480
                  ? "20px"
                  : window.innerWidth <= 768
                  ? "40px"
                  : window.innerWidth <= 1024
                  ? "50px"
                  : "60px",
            }}
          >
            *Unsubscribe anytime. We don’t send any spam
          </div>
        </div>
                   </div>
      
     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={phone}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>
            
                    <div
                      style={{
                        fontFamily: "Epilogue",
                        lineHeight: "1.4",
                        textAlign: "center",
                        padding: isMobile ? "15px 0" : "20px 0",
                        borderTop: "1px solid #ddd",
                        fontSize: isMobile ? "12px" : "14px",
                        color: "#333",
                      }}
                    >
                      Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
                    </div>
    </div>
  );
};

export default Features;
